import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export function Present(props: IconProps = {}): JSX.Element {
  const { ...rest } = props;
  return (
    <SvgIcon name="Present" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 1C6.95507 1 5.5 2.45507 5.5 4.25C5.5 4.69295 5.58861 5.1152 5.74908 5.5H2.5C1.11929 5.5 0 6.61929 0 8V14C0 14.8179 0.392777 15.5441 1 16.0002V20.5C1 21.8807 2.11929 23 3.5 23H20.5C21.8807 23 23 21.8807 23 20.5V16.0002C23.6072 15.5441 24 14.8179 24 14V8C24 6.61929 22.8807 5.5 21.5 5.5H18.2509C18.4114 5.1152 18.5 4.69295 18.5 4.25C18.5 2.45507 17.0449 1 15.25 1C13.6327 1 13.1032 1.81186 12.2827 3.06981C12.1926 3.20799 12.099 3.35155 12 3.5C11.901 3.35155 11.8074 3.20799 11.7173 3.06981C10.8968 1.81186 10.3673 1 8.75 1ZM10 4.25C10 4.94036 9.44036 5.5 8.75 5.5C8.05964 5.5 7.5 4.94036 7.5 4.25C7.5 3.55964 8.05964 3 8.75 3C9.44036 3 10 3.55964 10 4.25ZM2.5 7.5H9.35021L6.78555 11.4296L8.4604 12.5227L11 8.59397V14.5H2.5C2.22386 14.5 2 14.2761 2 14V8C2 7.72386 2.22386 7.5 2.5 7.5ZM11 16.5H3V20.5C3 20.7761 3.22386 21 3.5 21H11V16.5ZM13 21V16.5H21V20.5C21 20.7761 20.7761 21 20.5 21H13ZM13 14.5V8.56287L15.5887 12.5273L17.2585 11.4265L14.67 7.5H21.5C21.7761 7.5 22 7.72386 22 8V14C22 14.2761 21.7761 14.5 21.5 14.5H13ZM16.5 4.25C16.5 4.94036 15.9404 5.5 15.25 5.5C14.5596 5.5 14 4.94036 14 4.25C14 3.55964 14.5596 3 15.25 3C15.9404 3 16.5 3.55964 16.5 4.25Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
